export default {
    TODAS: 1,
    SELECIONADAS: 2,
}
